import React from "react";
import "../styles/ResearchSection.css";
import ResearchItem from "./ResearchItem";

const ResearchSection = () => {
  return (
    <div className="research-section">
      <h2>Media</h2>
      <div className="research-list">
        <ResearchItem
          title="BAT: Automatic bat call classification using transformer networks"
          image="BAT.png"
          authors={["Frank Fundel", "Daniel A. Braun", "Sebastian Gottwald"]}
          highlightedAuthor={0}
          journal="Ecological Informatics 2023"
          description="ConvNet-Transformer hybrid model enables sequence-based bat call classification, surpassing previous single call approaches.."
          arxivUrl="https://arxiv.org/abs/2309.11218"
          codeUrl="https://github.com/FrankFundel/BAT"
          highlighted
        />
        <ResearchItem
          title="SeaFar - Ocean Hackathon 2022 Winner"
          image="OceanHackathon2022.png"
          imageFit="cover"
          authors={["Frank Fundel", "Theodore Batik"]}
          highlightedAuthor={0}
          journal="Ocean Hackathon 2022 International Grand Finale, 3rd Place"
          description="Team SeaFar represented Cape Town with a dark vessel detection prototype that overlays AIS and non-AIS vessel locations on a map, using deep learning on high-frequency radar data to predict ships up to 150 km from the coast."
          videoUrl="https://www.youtube.com/watch?v=XYHokLozTzo"
          pressUrl="https://www.campusmer.fr/files/4189/oh6-press-kit-2023-vf-web3.pdf#page=29"
        />
      </div>
    </div>
  );
};

export default ResearchSection;
